export const PROGRESSION_SHOW_TABS = ['general'] as const;

export type ProgressionShowTab = (typeof PROGRESSION_SHOW_TABS)[number];

export const PROGRESSION_DEFAULT_TAB: ProgressionShowTab = 'general';
